import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReplyIcon from "@material-ui/icons/Reply";
import CallRounded from "@material-ui/icons/CallRounded";
import Spinner from "../../../../components/presentationals/Spinner";
import {
  Grid,
  Link,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Typography,
  Paper,
  IconButton,
} from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  table: {
    width: "-webkit-fill-available",
    minWidth: "30vw",
  },
  rows: {
    padding: 6,
    height: "3rem",
  },
  container: {
    maxHeight: 500,
  },
});
const StyledTableCell = withStyles((theme) => ({
  head: {
    //backgroundColor: "#dff0d8",
    borderColor: "#7d8675",
    color: "#3c763d",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const AtpOuter = ({
  getATPDash,
  getATPInner,
  showInner,
  setShowInner,
  selectedFSEId,
}) => {
  const classes = useStyles();
  const { atpFseObj, atpOuterObj, atpInnerObj } = useSelector(
    (state) => state.retailerPerformanceReducer
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  // console.log("fse from redux: ", atpFseObj);
  // console.log("atp outer from redux: ", atpOuterObj);
  // atpInnerObj && console.log("atp inner from redux: ", atpInnerObj);
  let currentCategory = "";

  useEffect(() => {
    getATPDash();
  }, [selectedFSEId]);

  let headerArray = [
    "Retailers Category",
    "LFM Activating",
    "LMTD Activating",
    "MTD Activating",
  ];
  if (showInner) {
    headerArray = [
      "Retailer",
      "",
      "Current Category",
      "LFM Activating",
      "LMTD Activating",
      "MTD Activating",
    ];
  }

  const atpArrayWithTotal = (arr) => {
    if (arr.length > 0) {
      var result = arr.reduce(function (acc, obj) {
        return {
          bucket: "Total",
          lfmActvnRetailers:
            parseInt(acc.lfmActvnRetailers) + parseInt(obj.lfmActvnRetailers),
          lmtdActvnRetailers:
            parseInt(acc.lmtdActvnRetailers) + parseInt(obj.lmtdActvnRetailers),
          mtdActvnRetailers:
            parseInt(acc.mtdActvnRetailers) + parseInt(obj.mtdActvnRetailers),
        };
      });
    } else {
      return arr;
    }
    arr = [...arr, result];
    return arr;
  };

  const onItemClick = (data, index) => {
    // console.log("selected Data", data);
    // setCurrentCategory(data.bucket);

    switch (data.bucket) {
      case "Zero (NIL)": {
        getATPInner(0, 0);
        break;
      }

      case "AMATEUR (1-4)":
        getATPInner(1, 4);
        break;

      case "PRO 1 (5-9)":
        getATPInner(5, 9);
        break;

      case "PRO 2 (10+)":
        getATPInner(10, 10000);
        break;

      default:
        break;
    }
  };

  const mtdNameColorCoding = (rowData) => {
    const lmtdActvnRetailers = rowData.lmtdActvnRetailers
        ? rowData.lmtdActvnRetailers
        : rowData.lmtdActvn,
      mtdActvnRetailers = rowData.mtdActvnRetailers
        ? rowData.mtdActvnRetailers
        : rowData.mtdActvn;
    // console.log("rowData => ", rowData)

    const bucket = rowData.bucket
      ? rowData.bucket
      : findThisMonthCategory(mtdActvnRetailers);

    let colorCode;
    if (
      (bucket == "AMATEUR (1-4)" ||
        bucket == "Zero (NIL)" ||
        bucket == "AMATEUR" ||
        bucket == "Zero") &&
      mtdActvnRetailers > lmtdActvnRetailers
    ) {
      colorCode = "#FF0000";
    } else if (
      (bucket == "PRO 2 (10+)" ||
        bucket == "PRO 1 (5-9)" ||
        bucket == "PRO 2" ||
        bucket == "PRO 1") &&
      mtdActvnRetailers < lmtdActvnRetailers
    ) {
      colorCode = "#FF0000";
    } else {
      colorCode = "#000";
    }

    // console.log(colorCode)
    return colorCode;
  };

  const findLastMonthCategory = (lmtdVal) => {
    let lastMonthCategory = "";
    if (lmtdVal == 0) {
      lastMonthCategory = "Zero";
    } else if (lmtdVal >= 1 && lmtdVal <= 4) {
      lastMonthCategory = "AMATEUR";
    } else if (lmtdVal >= 5 && lmtdVal <= 9) {
      lastMonthCategory = "PRO 1";
    } else if (lmtdVal >= 10) {
      lastMonthCategory = "PRO 2";
    }

    return lastMonthCategory;
  };

  const findThisMonthCategory = (mtdVal) => {
    let thisMonthCategory = "";
    if (mtdVal == 0) {
      thisMonthCategory = "Zero";
    } else if (mtdVal >= 1 && mtdVal <= 4) {
      thisMonthCategory = "AMATEUR";
    } else if (mtdVal >= 5 && mtdVal <= 9) {
      thisMonthCategory = "PRO 1";
    } else if (mtdVal >= 10) {
      thisMonthCategory = "PRO 2";
    }

    return thisMonthCategory;
  };

  const findCurrentCategory = (rowData) => {
    currentCategory = findThisMonthCategory(rowData.mtdActvn);
    return currentCategory;
  };

  const currentCategoryColorCoding = (rowData) => {
    // console.log("rowData ====> ", rowData);
    const lastMonth = findLastMonthCategory(rowData.lmtdActvn);
    // setCurrentCategory(thisMonth);

    // console.log("last month category = ", lastMonth);

    let categoriesRating = {
      Zero: 0,
      AMATEUR: 1,
      "PRO 1": 2,
      "PRO 2": 3,
    };
    let categoryColorCode;

    // console.log("currentCategory rating: ", )

    if (categoriesRating[lastMonth] > categoriesRating[currentCategory]) {
      categoryColorCode = "#FF0000";
    } else if (
      categoriesRating[lastMonth] < categoriesRating[currentCategory]
    ) {
      categoryColorCode = "#008000";
    }

    return categoryColorCode;
  };

  return (
    <>
      <div style={{ marginTop: "2rem", width: "-webkit-fill-available" }}>
        {showInner}
        <div className="dataTables_wrapper no-footer">
          {(atpOuterObj && atpOuterObj.loading) ||
          (atpInnerObj && atpInnerObj.loading) ? (
            <Spinner />
          ) : (
            <Grid
              container
              alignContent="space-around"
              justifyContent="center"
              data-cy="pagination-table"
            >
              <Grid item sm={12} className="table">
                <TableContainer className={classes.container} component={Paper}>
                  {showInner ? (
                    <IconButton
                      aria-label="back"
                      onClick={() => setShowInner(false)}
                    >
                      <ReplyIcon color="primary" />
                    </IconButton>
                  ) : null}
                  <Table
                    // id="summaryTable"
                    className={classes.table}
                    stickyHeader
                    aria-label="custom pagination table"
                  >
                    <TableHead>
                      <TableRow role="row" className={classes.rows}>
                        {headerArray.map((data, index) => {
                          return (
                            <StyledTableCell
                              key={index}
                              className="sorting_disabled dt-center align-middle px-2 py-2"
                            >
                              {data}
                            </StyledTableCell>
                          );
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {showInner ? (
                        atpInnerObj?.atpInnerData[0]?.length > 0 ? (
                          atpInnerObj?.atpInnerData[0]?.map((data, index) => {
                            return (
                              <TableRow
                                role="row"
                                key={index + 1}
                                className={classes.rows}
                              >
                                <StyledTableCell className="dt-center text-start align-middle px-2 py-2">
                                  {data.partnerName}
                                </StyledTableCell>
                                <StyledTableCell>
                                  <Link href={`tel:${data.primaryNo}`}>
                                    <CallRounded
                                      style={{ color: "blue" }}
                                      // onClick={() => captureCallLogs("SC_FSE_CALLED")}
                                    />
                                  </Link>
                                </StyledTableCell>
                                <StyledTableCell
                                  className="dt-center align-middle px-2 py-2"
                                  onLoad={
                                    (currentCategory =
                                      findCurrentCategory(data))
                                  }
                                  style={{
                                    color: currentCategoryColorCoding(data),
                                  }}
                                >
                                  {currentCategory}
                                </StyledTableCell>
                                <StyledTableCell className="dt-center align-middle px-2 py-2">
                                  {data.lfmActvn}
                                </StyledTableCell>
                                <StyledTableCell className="dt-center align-middle px-2 py-2">
                                  {data.lmtdActvn}
                                </StyledTableCell>
                                <StyledTableCell
                                  className="dt-center align-middle px-2 py-2"
                                  style={{
                                    color: mtdNameColorCoding(data),
                                  }}
                                >
                                  {data.mtdActvn}
                                </StyledTableCell>
                              </TableRow>
                            );
                          })
                        ) : (
                          <TableRow role="row">
                            <StyledTableCell
                              className="dt-center align-middle px-2 py-2"
                              colSpan={6}
                            >
                              No data available
                            </StyledTableCell>
                          </TableRow>
                        )
                      ) : (
                        <>
                          {atpOuterObj?.atpOuterData[0]
                            ? atpArrayWithTotal(
                                atpOuterObj?.atpOuterData[0]
                              ).map((row, index) => {
                                return row.bucket === "Total" ? (
                                  <TableRow
                                    role="row"
                                    key={index + 1}
                                    className={classes.rows}
                                  >
                                    <StyledTableCell
                                      className="dt-center text-start align-middle px-2 py-2"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {row.bucket}
                                    </StyledTableCell>

                                    <StyledTableCell
                                      className="dt-center align-middle px-2 py-2"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {row.lfmActvnRetailers}
                                    </StyledTableCell>

                                    <StyledTableCell
                                      className="dt-center align-middle px-2 py-2"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {row.lmtdActvnRetailers}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className="dt-center align-middle px-2 py-2"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {row.mtdActvnRetailers}
                                    </StyledTableCell>
                                  </TableRow>
                                ) : (
                                  <TableRow
                                    role="row"
                                    key={index + 1}
                                    className={classes.rows}
                                  >
                                    <StyledTableCell className="dt-center text-start align-middle px-2 py-2">
                                      {row.bucket}
                                    </StyledTableCell>

                                    <StyledTableCell
                                      className="dt-center align-middle px-2 py-2"
                                      onClick={() => onItemClick(row, index)}
                                      style={{
                                        cursor: "pointer",
                                        color: "#0096FF",
                                      }}
                                    >
                                      {row.lfmActvnRetailers}
                                    </StyledTableCell>

                                    <StyledTableCell className="dt-center align-middle px-2 py-2">
                                      {row.lmtdActvnRetailers}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      className="dt-center align-middle px-2 py-2"
                                      style={{
                                        color: mtdNameColorCoding(row),
                                      }}
                                    >
                                      {row.mtdActvnRetailers}
                                    </StyledTableCell>
                                  </TableRow>
                                );
                              })
                            : null}
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          )}
        </div>
      </div>
    </>
  );
};

export default AtpOuter;
